import React, {forwardRef} from "react";
import "../InvoicePage.scss";
import { ReactComponent as GzLogo } from "../../../icons/gz-icon-lg.svg";

import InvoiceCustomerComponent from "./InvoiceCustomerComponent";
import InvoiceSellerComponent from "./InvoiceSellerComponent";
import InvoicePriceComponent from "./InvoicePriceComponent";
import InvoiceOrderComponent from "./InvoiceOrderComponent";
import { useContent, useLanguages } from "../../../hooks/content";
import { Returntext } from "../../Landings/common/returnText";

const InvoicePdfComponent = forwardRef(({ props }, ref) => {
    const { lang } = useLanguages();
    const { contentManagementData } = useContent();

    return (
        <div className="pdf-wrapper">
            <div ref={ref} className="invoice-container invoice-container-pdf">
                <div className="header-left">
                    <div>
                        { Returntext(contentManagementData, 'poi_pdf_title', lang) }
                    </div>
                    <div> #{props.invoice_id} </div>
                    <div>
                        { Returntext(contentManagementData, 'poi_pdf_date_label', lang) }: { props.invoice_date }
                    </div>
                </div>
                <div className="header-right">
                    <GzLogo width={365} height={125} />
                </div>
                <div className="customer" >
                    <InvoiceCustomerComponent props={props.issuer} />
                </div>
                <div className="service-rovider">
                    <InvoiceSellerComponent props={props.service_providers} />
                </div>
                <div className="costs" >
                    <InvoicePriceComponent props={props.costs} />
                </div>
                <div className="orders" >
                    <InvoiceOrderComponent props={props.orders} pdf={true}/>
                </div>
                <div className="footer" >

                </div>
            </div>
        </div>
    );
});

export default InvoicePdfComponent;